import { render } from "./TheEmpty.vue?vue&type=template&id=7bb889c8"
import script from "./TheEmpty.vue?vue&type=script&lang=js"
export * from "./TheEmpty.vue?vue&type=script&lang=js"

import "./TheEmpty.vue?vue&type=style&index=0&id=7bb889c8&lang=scss"

import exportComponent from "/Users/chenjun/Desktop/myProject/pbl-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__